import { ALL_CENTRES } from '@appTypes/auth';
import { useAppShellStore } from '@store/appShellStore';
import { Outlet } from 'react-router-dom';

import { CentrePickerGate } from './CentrePickerGate';

/**
 * Gate for routes that need exactly ONE centre. The top-bar "All Centres"
 * selection is a read-only rollup over a whole main centre — Dashboard and
 * Reports understand it, but every other page reads or writes records that
 * belong to a specific centre, and the API refuses those requests outright.
 *
 * Rather than let the page mount and fill with failed requests, this offers an
 * inline picker to leave the rollup. The "no centres exist at all" case is
 * handled one level up by CentreRequiredRoute.
 */
export const SingleCentreRoute = () => {
  const centreId = useAppShellStore((s) => s.centreId);

  if (centreId !== ALL_CENTRES) return <Outlet />;

  return (
    <CentrePickerGate
      title="Select a centre to continue"
      description="You're viewing all centres combined. That view is read-only and works on the Dashboard and Reports — this page needs one specific centre."
    />
  );
};
